var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('img',{attrs:{"src":_vm.image}}),_c('div',{staticClass:"title"},[_vm._v("你访问的页面找不到了")]),_c('el-button',{attrs:{"type":"primary","plain":"","round":""},on:{"click":_vm.goMain}},[_vm._v(" 返回首页 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }